// Temps vendu : Jira fait foi et la synchro recopie celui de l'epic sur la brique. Une modification
// faite dans l'appli est donc renvoyée à Jira, mais SEULEMENT si le temps vendu a réellement changé
// sur le même epic : renvoyer à chaque enregistrement (ex. simple renommage) écraserait dans Jira une
// valeur plus récente pas encore recopiée par la synchro.
export function shouldPushSoldDays(
  previous: { epic?: string | null; soldDays?: number | null } | null | undefined,
  next: { epic?: string | null; soldDays: number },
): boolean {
  if (!next.epic || !previous || previous.epic !== next.epic) return false;
  return Number(previous.soldDays || 0) !== next.soldDays;
}
